module.exports = __webpack_public_path__ + "img/record-bg.26fb68c3.svg";